var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header mb-0",attrs:{"id":"marqii-header"}},[_c('div',{staticClass:"header-body"},[_c('div',{staticClass:"d-flex align-items-center justify-content-between"},[_c('div',{staticClass:"ml-2"},[_c('h1',{staticClass:"header-title ml-3"},[_vm._v("Listings and Review Management")])])])])])
}]

export { render, staticRenderFns }